import { render } from "./relatorio-layout.vue?vue&type=template&id=73de6d6a"
import script from "./relatorio-layout.vue?vue&type=script&lang=js"
export * from "./relatorio-layout.vue?vue&type=script&lang=js"

import "./relatorio-layout.vue?vue&type=style&index=0&id=73de6d6a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__